import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { useSelector } from "react-redux";
import { useMaterialUIController } from "../../context";
import SimpleMap from "../../layouts/dashboard/components/SimpleMap";
import { GetMapReportCall } from "../../redux/api/report.api";

export default function AdminStatsMap() {
  const [controller] = useMaterialUIController();
  const darkMode = controller?.darkMode === true;
  const mapReport = useSelector((state) => state?.report?.map);
  const data = mapReport?.data?.users_by_country ?? mapReport?.users_by_country;

  useEffect(() => {
    GetMapReportCall();
  }, []);

  if (!data) {
    return (
      <Skeleton
        variant="rounded"
        height={420}
        sx={{ borderRadius: 2, maxWidth: "100%" }}
      />
    );
  }

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No map data available yet.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: darkMode ? "#0c0f14" : "background.default",
        minHeight: { xs: 360, md: 420 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "100%", px: { xs: 0, sm: 1 }, py: 1 }}>
        <SimpleMap />
      </Box>
    </Box>
  );
}
